/**
 * the enum for the dorms
 */

export const Dorms = {
    Dorms: "יש מגורים",
    no: "אין מגורים"
}